// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// Traducciones
const resources = {
  en: {
    translation: {
      // Navigation
      Home: "Home",
      Competitions: "Competitions",
      Rules: "Rules",
      Gallery: "Gallery",
      Contact: "Contact",
      "My Productions": "My Productions",
      Profile: "Profile",
      "Sign out": "Sign out",
      Administration: "Administration",
      "Demo Party": "Demo Party",
      User: "User",

      // Auth
      "Forgot your Password?": "Forgot your Password?",
      "Don't have an account?": "Don't have an account?",
      "Sing Up": "Sign Up",
      "Sign Up": "Sign Up",
      "Sign in with Google": "Sign in with Google",
      "Sign in with SceneID": "Sign in with SceneID",
      "Sign in": "Sign in",
      "Sign In": "Sign In",
      "Invalid email or password. Please try again.": "Invalid email or password. Please try again.",
      "An unexpected error occurred. Please try again later.": "An unexpected error occurred. Please try again later.",

      // Admin Menu
      Dashboard: "Dashboard",
      Editions: "Editions",
      Productions: "Productions",
      "Voting Config": "Voting Config",
      Jury: "Jury",

      // Admin Pages - Titles
      "Administration Panel": "Administration Panel",
      "Editions Management": "Editions Management",
      "Competitions Management": "Competitions Management",
      "Productions Management": "Productions Management",
      "Jury Management": "Jury Management",
      "Voting Configuration": "Voting Configuration",
      "Attendance Codes": "Attendance Codes",
      "Edition Detail": "Edition Detail",
      "Competition Detail": "Competition Detail",
      "Production Detail": "Production Detail",
      "New Edition": "New Edition",
      "Edit Edition": "Edit Edition",
      "New Competition": "New Competition",
      "Edit Competition": "Edit Competition",

      // Admin Dashboard
      "Registered Users": "Registered Users",
      "Votes Cast": "Votes Cast",
      "Welcome to Administration Panel": "Welcome to Administration Panel",

      // Actions
      "View detail": "View detail",
      Edit: "Edit",
      Delete: "Delete",
      Save: "Save",
      Cancel: "Cancel",
      Create: "Create",
      Update: "Update",
      "Delete Edition": "Delete Edition",
      "Delete Competition": "Delete Competition",
      "Delete Production": "Delete Production",
      "Delete Configuration": "Delete Configuration",
      "Delete Jury Member": "Delete Jury Member",

      // Voting Config Labels
      "100% Public": "100% Public",
      "100% Jury": "100% Jury",
      Mixed: "Mixed",
      Open: "Open",
      "Attendance Code": "Attendance Code",
      "Manual Verification": "Manual Verification",
      "QR Check-in": "QR Check-in",

      // Dashboard descriptions
      "Create and manage party editions": "Create and manage party editions",
      "Configure competition types (compos)": "Configure competition types (compos)",
      "Configure voting system and juries": "Configure voting system and juries",
      "Manage all aspects of DPMS system from this centralized panel.": "Manage all aspects of DPMS system from this centralized panel.",
      "Manage Editions": "Manage Editions",
      "Manage Compos": "Manage Compos",
      "Configure Voting": "Configure Voting",
      Voting: "Voting",

      // Voting page
      "Vote": "Vote",
      "Vote saved": "Vote saved",
      "Error saving vote": "Error saving vote",
      "Error loading voting data": "Error loading voting data",
      "No open voting periods at this time.": "No open voting periods at this time.",
      "No productions available for voting.": "No productions available for voting.",
      "Your vote": "Your vote",
      "Rate this production": "Rate this production",
      "Time remaining": "Time remaining",
      "voted": "voted",
      "Voting ended": "Voting ended",
      "Jury voting only": "Jury voting only",
      "Mixed voting (public + jury)": "Mixed voting (public + jury)",
      "Public voting": "Public voting",
      "Voting Periods": "Voting Periods",
      "Breakdown": "Breakdown",
      "Jury": "Jury",

      // Table Headers
      Title: "Title",
      Description: "Description",
      "Open Submissions": "Open Submissions",
      Compos: "Compos",
      Created: "Created",
      Actions: "Actions",
      Name: "Name",
      Authors: "Authors",
      Edition: "Edition",
      Closed: "Closed",
      Icon: "Icon",
      Order: "Order",
      "Rows per page:": "Rows per page:",
      of: "of",

      // Filter Labels
      All: "All",
      Competition: "Competition",
      Status: "Status",
      Pending: "Pending",
      Approved: "Approved",
      Rejected: "Rejected",
      Ranking: "Ranking",
      Submitted: "Submitted",

      // Search & Empty States
      "Search editions...": "Search editions...",
      "Search competitions...": "Search competitions...",
      "Search productions...": "Search productions...",
      "No editions found": "No editions found",
      "No editions. Create a new one to get started.": "No editions. Create a new one to get started.",
      "No competitions found": "No competitions found",
      "No competitions. Create a new one to get started.": "No competitions. Create a new one to get started.",
      "No productions found": "No productions found",
      "No productions yet.": "No productions yet.",

      // Confirmations
      'Are you sure you want to delete the edition "{{title}}"? This action cannot be undone.': 'Are you sure you want to delete the edition "{{title}}"? This action cannot be undone.',
      'Are you sure you want to delete the competition "{{name}}"? This action cannot be undone.': 'Are you sure you want to delete the competition "{{name}}"? This action cannot be undone.',
      'Are you sure you want to delete the production "{{title}}"? This action cannot be undone.': 'Are you sure you want to delete the production "{{title}}"? This action cannot be undone.',
      'Are you sure you want to delete the voting configuration for "{{title}}"? This action cannot be undone.': 'Are you sure you want to delete the voting configuration for "{{title}}"? This action cannot be undone.',
      'Are you sure you want to remove {{name}} from the jury? This action cannot be undone.': 'Are you sure you want to remove {{name}} from the jury? This action cannot be undone.',

      // Sponsors
      Sponsors: "Sponsors",
      "Sponsors Management": "Sponsors Management",
      "New Sponsor": "New Sponsor",
      "Edit Sponsor": "Edit Sponsor",
      "Delete Sponsor": "Delete Sponsor",
      "Search sponsors...": "Search sponsors...",
      "No sponsors found": "No sponsors found",
      "No sponsors. Create a new one to get started.": "No sponsors. Create a new one to get started.",
      'Are you sure you want to delete the sponsor "{{name}}"? This action cannot be undone.': 'Are you sure you want to delete the sponsor "{{name}}"? This action cannot be undone.',
      "Back to Sponsors": "Back to Sponsors",
      "Website URL": "Website URL",
      Website: "Website",
      Logo: "Logo",
      "Upload Logo": "Upload Logo",
      "Display Order": "Display Order",
      "Lower numbers appear first": "Lower numbers appear first",
      "Sponsor created successfully": "Sponsor created successfully",
      "Sponsor updated successfully": "Sponsor updated successfully",
      "Error loading sponsors": "Error loading sponsors",
      "Error loading sponsor": "Error loading sponsor",
      "Error saving sponsor": "Error saving sponsor",
      "Error deleting sponsor": "Error deleting sponsor",
      "Saving...": "Saving...",
      New: "New",

      // Common
      Loading: "Loading...",
      Error: "Error",
      Success: "Success",
      Yes: "Yes",
      No: "No",
      Public: "Public",
      Private: "Private",
      Active: "Active",
      Inactive: "Inactive",

      // StageRunner
      StageRunner: "StageRunner",
      "StageRunner Dashboard": "StageRunner Dashboard",
      "Slides Management": "Slides Management",
      "Live Control": "Live Control",
      "StageRunner Settings": "StageRunner Settings",
      Slides: "Slides",
      "New Slide": "New Slide",
      "Edit Slide": "Edit Slide",
      "Delete Slide": "Delete Slide",
      "Slide Editor": "Slide Editor",
      "Open Beamer": "Open Beamer",
      "Open Visualizer": "Open Visualizer",
      Preview: "Preview",
      "No slides found": "No slides found",
      "No slides. Create a new one to get started.": "No slides. Create a new one to get started.",
      "Search slides...": "Search slides...",
      'Are you sure you want to delete the slide "{{name}}"? This action cannot be undone.': 'Are you sure you want to delete the slide "{{name}}"? This action cannot be undone.',
      "Slide created successfully": "Slide created successfully",
      "Slide updated successfully": "Slide updated successfully",
      "Error loading slides": "Error loading slides",
      "Error saving slide": "Error saving slide",
      "Error deleting slide": "Error deleting slide",
      "Duplicate Slide": "Duplicate Slide",
      "Slide duplicated successfully": "Slide duplicated successfully",

      // Slide Types
      "Custom Layout": "Custom Layout",
      "Idle/Waiting": "Idle/Waiting",
      Countdown: "Countdown",
      "Production List": "Production List",
      "Production Show": "Production Show",
      Results: "Results",

      // Element Types
      Text: "Text",
      Image: "Image",
      Video: "Video",
      "Scrolling Text": "Scrolling Text",
      Clock: "Clock",
      "Countdown Timer": "Countdown Timer",
      "Production Info": "Production Info",
      "Sponsor Bar": "Sponsor Bar",

      // Transitions
      None: "None",
      Fade: "Fade",
      "Slide from Left": "Slide from Left",
      "Slide from Right": "Slide from Right",
      "Slide from Bottom": "Slide from Bottom",
      "Slide from Top": "Slide from Top",
      "Zoom In": "Zoom In",
      Bounce: "Bounce",

      // Background Effects
      Hyperspace: "Hyperspace",
      Wave: "Wave",
      "Energy Grid": "Energy Grid",
      "Tron Grid": "Tron Grid",
      "Use Default": "Use Default",

      // Editor Labels
      "Add Element": "Add Element",
      Elements: "Elements",
      Layers: "Layers",
      Properties: "Properties",
      Position: "Position",
      Size: "Size",
      Style: "Style",
      Transition: "Transition",
      "Enter Transition": "Enter Transition",
      "Exit Transition": "Exit Transition",
      Duration: "Duration",
      Delay: "Delay",
      "Background Effect": "Background Effect",
      "Background Image": "Background Image",
      "Background Color": "Background Color",
      "Slide Type": "Slide Type",
      "Slide Name": "Slide Name",
      Rotation: "Rotation",
      "Z-Index": "Z-Index",
      Visible: "Visible",
      Content: "Content",

      // Production Form
      "Submit Production": "Submit Production",
      "Edit Production": "Edit Production",
      "Full name of the author(s)": "Full name of the author(s)",
      "Group(s)": "Group(s)",
      "Group(s) the authors belong to (if applicable)": "Group(s) the authors belong to (if applicable)",
      "Contact email": "Contact email",
      Platform: "Platform",
      "Not specified": "Not specified",
      "Minimum machine required": "Minimum machine required",
      "Minimum hardware/software required to run the production": "Minimum hardware/software required to run the production",
      "Technical details & Licensing": "Technical details & Licensing",
      "Tools used for development": "Tools used for development",
      "List all tools used (compilers, editors, frameworks, etc.)": "List all tools used (compilers, editors, frameworks, etc.)",
      "Third-party resources": "Third-party resources",
      "List third-party resources included with links to their licenses": "List third-party resources included with links to their licenses",
      "License texts for distribution": "License texts for distribution",
      "License texts that need to be included in the distribution": "License texts that need to be included in the distribution",
      "AI tools used": "AI tools used",
      "If AI tools were used (even partially), specify which tools and in which parts": "If AI tools were used (even partially), specify which tools and in which parts",
      "Additional information": "Additional information",
      "Development process, custom tools, or any other relevant info": "Development process, custom tools, or any other relevant info",
      Submit: "Submit",
      "Submitting...": "Submitting...",

      // Profile Page
      "Personal Information": "Personal Information",
      "First Name": "First Name",
      "Last Name": "Last Name",
      Nickname: "Nickname",
      Group: "Group",
      Email: "Email",
      "Email cannot be changed": "Email cannot be changed",
      "About me": "About me",
      "Show me in the visitors list": "Show me in the visitors list",
      "Visible in visitors list": "Visible in visitors list",
      "Save changes": "Save changes",
      "Profile updated successfully": "Profile updated successfully",
      "Failed to update profile": "Failed to update profile",
      "Failed to load profile data": "Failed to load profile data",

      // Gallery
      "Error loading gallery": "Error loading gallery",
      "Select an image": "Select an image",
      "Error uploading image": "Error uploading image",
      "Upload Image": "Upload Image",
      "All images": "All images",
      "My images": "My images",
      "Filter by edition": "Filter by edition",
      "All editions": "All editions",
      "Clear filter": "Clear filter",
      "No images in the gallery": "No images in the gallery",
      "Upload the first image": "Upload the first image",
      "You haven't uploaded any images yet": "You haven't uploaded any images yet",
      "Upload my first image": "Upload my first image",
      "Click or drag an image here": "Click or drag an image here",
      "JPG, PNG, GIF, WebP (max. 20MB)": "JPG, PNG, GIF, WebP (max. 20MB)",
      "Title (optional)": "Title (optional)",
      "Description (optional)": "Description (optional)",
      "No edition": "No edition",
      Upload: "Upload",
      "Uploading...": "Uploading...",
      "Edit Image": "Edit Image",
      "Delete Image": "Delete Image",
      "Are you sure you want to delete this image? This action cannot be undone.": "Are you sure you want to delete this image? This action cannot be undone.",

      // Dashboard
      "Error loading dashboard data": "Error loading dashboard data",
      "Next Event": "Next Event",
      "View Competitions": "View Competitions",
      Days: "Days",
      Hours: "Hours",
      Min: "Min",
      Sec: "Sec",
      "Open Competitions": "Open Competitions",
      "Days Remaining": "Days Remaining",
      "Current Edition": "Current Edition",
      open: "open",
      "No open competitions at this time": "No open competitions at this time",
      "Closes:": "Closes:",
      Participate: "Participate",
      "View All Competitions": "View All Competitions",
      "You haven't uploaded any productions yet": "You haven't uploaded any productions yet",
      "Upload my first production": "Upload my first production",
      "Quick Actions": "Quick Actions",
      "View all competitions": "View all competitions",
      "Manage my works": "Manage my works",
      "New Production": "New Production",
      "Upload a work": "Upload a work",
      "My Profile": "My Profile",
      "Configure account": "Configure account",

      // My Productions
      "Error loading your productions": "Error loading your productions",
      "Submit New Production": "Submit New Production",
      "No productions yet": "No productions yet",
      "You haven't submitted any productions yet. Start by choosing a competition!": "You haven't submitted any productions yet. Start by choosing a competition!",
      "Browse Competitions": "Browse Competitions",
      "Files:": "Files:",
      "Submitted:": "Submitted:",
      "View details": "View details",
      "Edit production": "Edit production",
      "Delete production": "Delete production",
      "Confirm Delete": "Confirm Delete",
      "Are you sure you want to delete this production? This action cannot be undone.": "Are you sure you want to delete this production? This action cannot be undone.",
      "Deleting...": "Deleting...",

      // Production Detail
      "Error loading production details": "Error loading production details",
      "Production not found": "Production not found",
      "Go Back": "Go Back",
      Back: "Back",
      Files: "Files",
      "No files attached to this production.": "No files attached to this production.",
      "Last modified:": "Last modified:",
      "By:": "By:",
      "Upload Files": "Upload Files",
      "No files uploaded yet. Max file size: 100MB per file.": "No files uploaded yet. Max file size: 100MB per file.",

      // Control
      "Previous Slide": "Previous Slide",
      "Next Slide": "Next Slide",
      Play: "Play",
      Pause: "Pause",
      "Auto Advance": "Auto Advance",
      "Current Slide": "Current Slide",
      "No Edition Selected": "No Edition Selected",
      "Select an edition to configure StageRunner": "Select an edition to configure StageRunner",
      "Create Configuration": "Create Configuration",
      "Configuration created successfully": "Configuration created successfully",

      // Attendance
      "I'm going": "I'm going",
      "Your attendance": "Your attendance",
      "Equipment you bring": "Equipment you bring",
      "e.g. Amiga 500, external monitor, mixer, a few extension cords…": "e.g. Amiga 500, external monitor, mixer, a few extension cords…",
      "Where will you sleep?": "Where will you sleep?",
      "At the party": "At the party",
      Outside: "Outside",
      "Days you will attend": "Days you will attend",
      "Dates not yet available for this edition.": "Dates not yet available for this edition.",
      Withdraw: "Withdraw",
      "Update attendance": "Update attendance",
      "Back to dashboard": "Back to dashboard",
      "Attendance confirmed. Thanks for coming!": "Attendance confirmed. Thanks for coming!",
      "Could not save your attendance. Please try again.": "Could not save your attendance. Please try again.",
      "This will cancel your attendance confirmation. Continue?": "This will cancel your attendance confirmation. Continue?",
      "Your attendance has been withdrawn.": "Your attendance has been withdrawn.",
      "Could not withdraw your attendance. Please try again.": "Could not withdraw your attendance. Please try again.",
      "We could not load your attendance. Please try again.": "We could not load your attendance. Please try again.",
      "No upcoming edition is open for attendance right now.": "No upcoming edition is open for attendance right now.",
      "Attendance confirmations": "Attendance confirmations",
      "Search by name, email or nickname": "Search by name, email or nickname",
      "Search by email, nickname or equipment": "Search by email, nickname or equipment",
      Nickname: "Nickname",
      Name: "Name",
      Verified: "Verified",
      Attends: "Attends",
      Yes: "Yes",
      No: "No",
      Joined: "Joined",
      "Sleeps at": "Sleeps at",
      Days: "Days",
      Equipment: "Equipment",
      "Confirmed on": "Confirmed on",
      confirmed: "confirmed",
      "No users match your filter": "No users match your filter",
      "No confirmations yet": "No confirmations yet",
      "Could not load confirmations": "Could not load confirmations",
      "Could not load users": "Could not load users",
      "Failed to load editions": "Failed to load editions",
      Edition: "Edition",
      "Manage Users": "Manage Users",
      "View Confirmations": "View Confirmations",
      "Browse registered users and see who has confirmed attendance.": "Browse registered users and see who has confirmed attendance.",
      "Review attendance RSVPs, sleep arrangements and gear.": "Review attendance RSVPs, sleep arrangements and gear.",
    },
  },
  es: {
    translation: {
      // Navigation
      Home: "Inicio",
      Competitions: "Competiciones",
      Rules: "Normativa",
      Gallery: "Galería",
      Contact: "Contacto",
      "My Productions": "Mis Producciones",
      Profile: "Perfil",
      "Sign out": "Cerrar sesión",
      Administration: "Administración",
      "Demo Party": "Demo Party",
      User: "Usuario",

      // Auth
      "Forgot your Password?": "¿Olvidaste tu contraseña?",
      "Don't have an account?": "¿No tienes una cuenta?",
      "Sing Up": "Regístrate",
      "Sign Up": "Registrarse",
      "Sign in with Google": "Iniciar sesión con Google",
      "Sign in with SceneID": "Iniciar sesión con SceneID",
      "Sign in": "Iniciar sesión",
      "Sign In": "Iniciar Sesión",
      "Enter your email": "Introduce tu correo",
      "Enter your password": "Introduce tu contraseña",
      "Confirm your password": "Confirma tu contraseña",
      "Enter your group": "Introduce tu grupo",
      "Enter your nickname": "Introduce tu nick/apodo",
      "Enter your first name": "Introduce tu nombre",
      "Enter your last name": "Introduce tu apellido",
      "Invalid email or password. Please try again.": "Correo o contraseña inválidos. Por favor, inténtalo de nuevo.",
      "An unexpected error occurred. Please try again later.":
        "Ocurrió un error inesperado. Por favor, inténtalo de nuevo más tarde.",
      "Already have an account?": "¿Ya tienes una cuenta?",
      "Account Verification": "Verificación de Cuenta",
      "Please wait while we verify your account": "Por favor, espera mientras verificamos tu cuenta",
      "Welcome {{name}}! Your account is verified.": "¡Bienvenido {{name}}! Tu cuenta está verificada.",
      "Congratulations and welcome to Posadas Party community":
        "¡Felicidades y bienvenido a la comunidad de Posadas Party!",
      "Verification failed. Please try again": "La verificación falló. Por favor, inténtalo de nuevo",
      "Token is missing": "Falta el token",
      "An error occurred": "Ocurrió un error",
      "Sorry, the page you are looking for does not exist": "Lo siento, la página que buscas no existe",
      "A confirmation email has been sent to your email address. Please check your inbox to verify your account":
        "Se ha enviado un correo de confirmación a tu dirección de correo. Por favor, revisa tu bandeja de entrada para verificar tu cuenta",
      "Registration Complete": "Registro Completado",

      // Admin Menu
      Dashboard: "Panel",
      Editions: "Ediciones",
      Productions: "Producciones",
      "Voting Config": "Config. Votación",
      Jury: "Jurado",

      // Admin Pages - Titles
      "Administration Panel": "Panel de Administración",
      "Editions Management": "Gestión de Ediciones",
      "Competitions Management": "Gestión de Competiciones",
      "Productions Management": "Gestión de Producciones",
      "Jury Management": "Gestión de Jurado",
      "Voting Configuration": "Configuración de Votación",
      "Attendance Codes": "Códigos de Asistencia",
      "Edition Detail": "Detalle de Edición",
      "Competition Detail": "Detalle de Competición",
      "Production Detail": "Detalle de Producción",
      "New Edition": "Nueva Edición",
      "Edit Edition": "Editar Edición",
      "New Competition": "Nueva Competición",
      "Edit Competition": "Editar Competición",

      // Admin Dashboard
      "Registered Users": "Usuarios Registrados",
      "Votes Cast": "Votos Emitidos",
      "Welcome to Administration Panel": "Bienvenido al Panel de Administración",

      // Actions
      "View detail": "Ver detalle",
      Edit: "Editar",
      Delete: "Eliminar",
      Save: "Guardar",
      Cancel: "Cancelar",
      Create: "Crear",
      Update: "Actualizar",
      "Delete Edition": "Eliminar Edición",
      "Delete Competition": "Eliminar Competición",
      "Delete Production": "Eliminar Producción",
      "Delete Configuration": "Eliminar Configuración",
      "Delete Jury Member": "Eliminar Miembro del Jurado",

      // Voting Config Labels
      "100% Public": "100% Público",
      "100% Jury": "100% Jurado",
      Mixed: "Mixto",
      Open: "Abierto",
      "Attendance Code": "Código Asistencia",
      "Manual Verification": "Verificación Manual",
      "QR Check-in": "QR Check-in",

      // Dashboard descriptions
      "Create and manage party editions": "Crear y gestionar ediciones de parties",
      "Configure competition types (compos)": "Configurar tipos de competiciones (compos)",
      "Configure voting system and juries": "Configurar sistema de votación y jurados",
      "Manage all aspects of DPMS system from this centralized panel.": "Gestiona todos los aspectos del sistema DPMS desde este panel centralizado.",
      "Manage Editions": "Gestionar Ediciones",
      "Manage Compos": "Gestionar Compos",
      "Configure Voting": "Configurar Votación",
      Voting: "Votaciones",

      // Voting page
      "Vote": "Votar",
      "Vote saved": "Voto guardado",
      "Error saving vote": "Error al guardar el voto",
      "Error loading voting data": "Error al cargar datos de votación",
      "No open voting periods at this time.": "No hay períodos de votación abiertos en este momento.",
      "No productions available for voting.": "No hay producciones disponibles para votar.",
      "Your vote": "Tu voto",
      "Rate this production": "Puntúa esta producción",
      "Time remaining": "Tiempo restante",
      "voted": "votadas",
      "Voting ended": "Votación finalizada",
      "Jury voting only": "Solo votación de jurado",
      "Mixed voting (public + jury)": "Votación mixta (público + jurado)",
      "Public voting": "Votación pública",
      "Voting Periods": "Períodos de Votación",
      "Breakdown": "Desglose",
      "Jury": "Jurado",

      // Table Headers
      Title: "Título",
      Description: "Descripción",
      "Open Submissions": "Envíos Abiertos",
      Compos: "Compos",
      Created: "Creada",
      Actions: "Acciones",
      Name: "Nombre",
      Authors: "Autores",
      Edition: "Edición",
      Closed: "Cerrada",
      Icon: "Icono",
      Order: "Orden",
      "Rows per page:": "Filas por página:",
      of: "de",

      // Filter Labels
      All: "Todas",
      Competition: "Competición",
      Status: "Estado",
      Pending: "Pendiente",
      Approved: "Aprobada",
      Rejected: "Rechazada",
      Ranking: "Ranking",
      Submitted: "Enviado",

      // Search & Empty States
      "Search editions...": "Buscar ediciones...",
      "Search competitions...": "Buscar competiciones...",
      "Search productions...": "Buscar producciones...",
      "No editions found": "No se encontraron ediciones",
      "No editions. Create a new one to get started.": "No hay ediciones. Crea una nueva para empezar.",
      "No competitions found": "No se encontraron competiciones",
      "No competitions. Create a new one to get started.": "No hay competiciones. Crea una nueva para empezar.",
      "No productions found": "No se encontraron producciones",
      "No productions yet.": "Aún no hay producciones.",

      // Confirmations
      'Are you sure you want to delete the edition "{{title}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar la edición "{{title}}"? Esta acción no se puede deshacer.',
      'Are you sure you want to delete the competition "{{name}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar la competición "{{name}}"? Esta acción no se puede deshacer.',
      'Are you sure you want to delete the production "{{title}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar la producción "{{title}}"? Esta acción no se puede deshacer.',
      'Are you sure you want to delete the voting configuration for "{{title}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar la configuración de votación para "{{title}}"? Esta acción no se puede deshacer.',
      'Are you sure you want to remove {{name}} from the jury? This action cannot be undone.': '¿Estás seguro de que quieres eliminar a {{name}} del jurado? Esta acción no se puede deshacer.',

      // Sponsors
      Sponsors: "Patrocinadores",
      "Sponsors Management": "Gestión de Patrocinadores",
      "New Sponsor": "Nuevo Patrocinador",
      "Edit Sponsor": "Editar Patrocinador",
      "Delete Sponsor": "Eliminar Patrocinador",
      "Search sponsors...": "Buscar patrocinadores...",
      "No sponsors found": "No se encontraron patrocinadores",
      "No sponsors. Create a new one to get started.": "No hay patrocinadores. Crea uno nuevo para empezar.",
      'Are you sure you want to delete the sponsor "{{name}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar el patrocinador "{{name}}"? Esta acción no se puede deshacer.',
      "Back to Sponsors": "Volver a Patrocinadores",
      "Website URL": "URL del Sitio Web",
      Website: "Sitio Web",
      Logo: "Logo",
      "Upload Logo": "Subir Logo",
      "Display Order": "Orden de Visualización",
      "Lower numbers appear first": "Los números más bajos aparecen primero",
      "Sponsor created successfully": "Patrocinador creado exitosamente",
      "Sponsor updated successfully": "Patrocinador actualizado exitosamente",
      "Error loading sponsors": "Error al cargar patrocinadores",
      "Error loading sponsor": "Error al cargar patrocinador",
      "Error saving sponsor": "Error al guardar patrocinador",
      "Error deleting sponsor": "Error al eliminar patrocinador",
      "Saving...": "Guardando...",
      New: "Nuevo",

      // Common
      Loading: "Cargando...",
      Error: "Error",
      Success: "Éxito",
      Yes: "Sí",
      No: "No",
      Public: "Público",
      Private: "Privado",
      Active: "Activo",
      Inactive: "Inactivo",

      // StageRunner
      StageRunner: "StageRunner",
      "StageRunner Dashboard": "Panel de StageRunner",
      "Slides Management": "Gestión de Diapositivas",
      "Live Control": "Control en Vivo",
      "StageRunner Settings": "Configuración de StageRunner",
      Slides: "Diapositivas",
      "New Slide": "Nueva Diapositiva",
      "Edit Slide": "Editar Diapositiva",
      "Delete Slide": "Eliminar Diapositiva",
      "Slide Editor": "Editor de Diapositivas",
      "Open Beamer": "Abrir Proyector",
      "Open Visualizer": "Abrir Visualizador",
      Preview: "Vista Previa",
      "No slides found": "No se encontraron diapositivas",
      "No slides. Create a new one to get started.": "No hay diapositivas. Crea una nueva para empezar.",
      "Search slides...": "Buscar diapositivas...",
      'Are you sure you want to delete the slide "{{name}}"? This action cannot be undone.': '¿Estás seguro de que quieres eliminar la diapositiva "{{name}}"? Esta acción no se puede deshacer.',
      "Slide created successfully": "Diapositiva creada exitosamente",
      "Slide updated successfully": "Diapositiva actualizada exitosamente",
      "Error loading slides": "Error al cargar diapositivas",
      "Error saving slide": "Error al guardar diapositiva",
      "Error deleting slide": "Error al eliminar diapositiva",
      "Duplicate Slide": "Duplicar Diapositiva",
      "Slide duplicated successfully": "Diapositiva duplicada exitosamente",

      // Slide Types
      "Custom Layout": "Diseño Personalizado",
      "Idle/Waiting": "Espera/Inactivo",
      Countdown: "Cuenta Regresiva",
      "Production List": "Lista de Producciones",
      "Production Show": "Mostrar Producción",
      Results: "Resultados",

      // Element Types
      Text: "Texto",
      Image: "Imagen",
      Video: "Video",
      "Scrolling Text": "Texto en Movimiento",
      Clock: "Reloj",
      "Countdown Timer": "Temporizador",
      "Production Info": "Info de Producción",
      "Sponsor Bar": "Barra de Sponsors",

      // Transitions
      None: "Ninguna",
      Fade: "Desvanecer",
      "Slide from Left": "Deslizar desde Izquierda",
      "Slide from Right": "Deslizar desde Derecha",
      "Slide from Bottom": "Deslizar desde Abajo",
      "Slide from Top": "Deslizar desde Arriba",
      "Zoom In": "Zoom",
      Bounce: "Rebote",

      // Background Effects
      Hyperspace: "Hiperespacio",
      Wave: "Onda",
      "Energy Grid": "Rejilla de Energía",
      "Tron Grid": "Rejilla Tron",
      "Use Default": "Usar Predeterminado",

      // Editor Labels
      "Add Element": "Añadir Elemento",
      Elements: "Elementos",
      Layers: "Capas",
      Properties: "Propiedades",
      Position: "Posición",
      Size: "Tamaño",
      Style: "Estilo",
      Transition: "Transición",
      "Enter Transition": "Transición de Entrada",
      "Exit Transition": "Transición de Salida",
      Duration: "Duración",
      Delay: "Retardo",
      "Background Effect": "Efecto de Fondo",
      "Background Image": "Imagen de Fondo",
      "Background Color": "Color de Fondo",
      "Slide Type": "Tipo de Diapositiva",
      "Slide Name": "Nombre de Diapositiva",
      Rotation: "Rotación",
      "Z-Index": "Índice Z",
      Visible: "Visible",
      Content: "Contenido",

      // Production Form
      "Submit Production": "Enviar Producción",
      "Edit Production": "Editar Producción",
      "Full name of the author(s)": "Nombre completo del/los autor(es)",
      "Group(s)": "Grupo(s)",
      "Group(s) the authors belong to (if applicable)": "Grupo(s) a los que pertenecen los autores (si aplica)",
      "Contact email": "Email de contacto",
      Platform: "Plataforma",
      "Not specified": "No especificada",
      "Minimum machine required": "Máquina mínima requerida",
      "Minimum hardware/software required to run the production": "Hardware/software mínimo necesario para ejecutar la producción",
      "Technical details & Licensing": "Detalles técnicos y Licencias",
      "Tools used for development": "Herramientas usadas en el desarrollo",
      "List all tools used (compilers, editors, frameworks, etc.)": "Lista de todas las herramientas usadas (compiladores, editores, frameworks, etc.)",
      "Third-party resources": "Recursos de terceros",
      "List third-party resources included with links to their licenses": "Lista de recursos de terceros incluidos con enlaces a sus licencias",
      "License texts for distribution": "Textos de licencias para distribución",
      "License texts that need to be included in the distribution": "Textos de licencias que deben incluirse en la distribución",
      "AI tools used": "Herramientas de IA utilizadas",
      "If AI tools were used (even partially), specify which tools and in which parts": "Si se usaron herramientas de IA (aunque sea parcialmente), especifica cuáles y en qué partes",
      "Additional information": "Información adicional",
      "Development process, custom tools, or any other relevant info": "Proceso de desarrollo, herramientas propias u otra información relevante",
      Submit: "Enviar",
      "Submitting...": "Enviando...",

      // Profile Page
      "Personal Information": "Información Personal",
      "First Name": "Nombre",
      "Last Name": "Apellido",
      Nickname: "Apodo",
      Group: "Grupo",
      Email: "Email",
      "Email cannot be changed": "El email no se puede cambiar",
      "About me": "Sobre mí",
      "Show me in the visitors list": "Mostrarme en la lista de visitantes",
      "Visible in visitors list": "Visible en la lista de visitantes",
      "Save changes": "Guardar cambios",
      "Profile updated successfully": "Perfil actualizado correctamente",
      "Failed to update profile": "Error al actualizar el perfil",
      "Failed to load profile data": "Error al cargar los datos del perfil",

      // Gallery
      "Error loading gallery": "Error al cargar la galería",
      "Select an image": "Selecciona una imagen",
      "Error uploading image": "Error al subir la imagen",
      "Upload Image": "Subir Imagen",
      "All images": "Todas las imágenes",
      "My images": "Mis imágenes",
      "Filter by edition": "Filtrar por edición",
      "All editions": "Todas las ediciones",
      "Clear filter": "Limpiar filtro",
      "No images in the gallery": "No hay imágenes en la galería",
      "Upload the first image": "Sube la primera imagen",
      "You haven't uploaded any images yet": "Aún no has subido ninguna imagen",
      "Upload my first image": "Subir mi primera imagen",
      "Click or drag an image here": "Haz click o arrastra una imagen aquí",
      "JPG, PNG, GIF, WebP (max. 20MB)": "JPG, PNG, GIF, WebP (máx. 20MB)",
      "Title (optional)": "Título (opcional)",
      "Description (optional)": "Descripción (opcional)",
      "No edition": "Sin edición",
      Upload: "Subir",
      "Uploading...": "Subiendo...",
      "Edit Image": "Editar Imagen",
      "Delete Image": "Eliminar Imagen",
      "Are you sure you want to delete this image? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta imagen? Esta acción no se puede deshacer.",

      // Dashboard
      "Error loading dashboard data": "Error al cargar los datos del panel",
      "Next Event": "Próximo Evento",
      "View Competitions": "Ver Competiciones",
      Days: "Días",
      Hours: "Horas",
      Min: "Min",
      Sec: "Seg",
      "Open Competitions": "Compos Abiertas",
      "Days Remaining": "Días Restantes",
      "Current Edition": "Edición Actual",
      open: "abiertas",
      "No open competitions at this time": "No hay competiciones abiertas en este momento",
      "Closes:": "Cierre:",
      Participate: "Participar",
      "View All Competitions": "Ver Todas las Competiciones",
      "You haven't uploaded any productions yet": "Aún no has subido ninguna producción",
      "Upload my first production": "Subir mi primera producción",
      "Quick Actions": "Acciones Rápidas",
      "View all competitions": "Ver todas las compos",
      "Manage my works": "Gestionar mis obras",
      "New Production": "Nueva Producción",
      "Upload a work": "Subir una obra",
      "My Profile": "Mi Perfil",
      "Configure account": "Configurar cuenta",

      // My Productions
      "Error loading your productions": "Error al cargar tus producciones",
      "Submit New Production": "Enviar Nueva Producción",
      "No productions yet": "Aún no hay producciones",
      "You haven't submitted any productions yet. Start by choosing a competition!": "Aún no has enviado ninguna producción. ¡Empieza eligiendo una competición!",
      "Browse Competitions": "Ver Competiciones",
      "Files:": "Archivos:",
      "Submitted:": "Enviado:",
      "View details": "Ver detalles",
      "Edit production": "Editar producción",
      "Delete production": "Eliminar producción",
      "Confirm Delete": "Confirmar Eliminación",
      "Are you sure you want to delete this production? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta producción? Esta acción no se puede deshacer.",
      "Deleting...": "Eliminando...",

      // Production Detail
      "Error loading production details": "Error al cargar los detalles de la producción",
      "Production not found": "Producción no encontrada",
      "Go Back": "Volver",
      Back: "Atrás",
      Files: "Archivos",
      "No files attached to this production.": "No hay archivos adjuntos a esta producción.",
      "Last modified:": "Última modificación:",
      "By:": "Por:",
      "Upload Files": "Subir Archivos",
      "No files uploaded yet. Max file size: 100MB per file.": "No hay archivos subidos. Tamaño máximo: 100MB por archivo.",

      // Control
      "Previous Slide": "Diapositiva Anterior",
      "Next Slide": "Siguiente Diapositiva",
      Play: "Reproducir",
      Pause: "Pausar",
      "Auto Advance": "Avance Automático",
      "Current Slide": "Diapositiva Actual",
      "No Edition Selected": "Ninguna Edición Seleccionada",
      "Select an edition to configure StageRunner": "Selecciona una edición para configurar StageRunner",
      "Create Configuration": "Crear Configuración",
      "Configuration created successfully": "Configuración creada exitosamente",

      // Attendance
      "I'm going": "Voy a ir",
      "Your attendance": "Tu asistencia",
      "Equipment you bring": "Equipo que traes",
      "e.g. Amiga 500, external monitor, mixer, a few extension cords…": "p. ej. Amiga 500, monitor externo, mesa de mezclas, un par de alargadores…",
      "Where will you sleep?": "¿Dónde duermes?",
      "At the party": "En la party",
      Outside: "Fuera",
      "Days you will attend": "Días que asistirás",
      "Dates not yet available for this edition.": "Aún no hay fechas disponibles para esta edición.",
      Withdraw: "Cancelar asistencia",
      "Update attendance": "Actualizar asistencia",
      "Back to dashboard": "Volver al panel",
      "Attendance confirmed. Thanks for coming!": "Asistencia confirmada. ¡Gracias por venir!",
      "Could not save your attendance. Please try again.": "No pudimos guardar tu asistencia. Inténtalo de nuevo.",
      "This will cancel your attendance confirmation. Continue?": "Esto cancelará tu confirmación de asistencia. ¿Continuar?",
      "Your attendance has been withdrawn.": "Tu asistencia se ha cancelado.",
      "Could not withdraw your attendance. Please try again.": "No pudimos cancelar tu asistencia. Inténtalo de nuevo.",
      "We could not load your attendance. Please try again.": "No pudimos cargar tu asistencia. Inténtalo de nuevo.",
      "No upcoming edition is open for attendance right now.": "No hay ninguna edición abierta para confirmar asistencia ahora mismo.",
      "Attendance confirmations": "Confirmaciones de asistencia",
      "Search by name, email or nickname": "Buscar por nombre, email o nick",
      "Search by email, nickname or equipment": "Buscar por email, nick o equipo",
      Nickname: "Nick",
      Name: "Nombre",
      Verified: "Verificado",
      Attends: "Asiste",
      Yes: "Sí",
      No: "No",
      Joined: "Registrado",
      "Sleeps at": "Duerme en",
      Days: "Días",
      Equipment: "Equipo",
      "Confirmed on": "Confirmado el",
      confirmed: "confirmados",
      "No users match your filter": "Ningún usuario coincide con el filtro",
      "No confirmations yet": "Aún no hay confirmaciones",
      "Could not load confirmations": "No pudimos cargar las confirmaciones",
      "Could not load users": "No pudimos cargar los usuarios",
      "Failed to load editions": "No pudimos cargar las ediciones",
      Edition: "Edición",
      "Manage Users": "Gestionar usuarios",
      "View Confirmations": "Ver confirmaciones",
      "Browse registered users and see who has confirmed attendance.": "Explora los usuarios registrados y mira quién ha confirmado asistencia.",
      "Review attendance RSVPs, sleep arrangements and gear.": "Revisa las confirmaciones, dónde duermen y el equipo que traen.",
    },
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
